import React, { FunctionComponent } from 'react';

import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../init-store';
import { Switch } from '../../../components/switch';
import { i18n } from '../../../helpers/i18n';
import { toggleShowMyVideoSettings } from '../../settings';
import css from './styles.css';

const mapState = ({
    settings: {
        media: { showMyVideo },
    },
}: RootState) => ({
    showMyVideo,
});

const connector = connect(mapState, { toggleShowMyVideoSettings });

export type MyVideoSwitchProps = ConnectedProps<typeof connector>;

const MyVideoToggle: FunctionComponent<MyVideoSwitchProps> = ({ showMyVideo, toggleShowMyVideoSettings }) => {
    return (
        <Switch
            labelBefore={i18n('settings', 'show-my-video')}
            className={css.switch}
            checked={showMyVideo}
            onChange={() => toggleShowMyVideoSettings()}
            size="md"
            stretch
            shrink
        />
    );
};

export default connector(MyVideoToggle);
